import { LitEntity, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { StoreMixin } from '../utility/store-mixin';
import { NoMenuMixin } from '../utility/no-menu-mixin';
import { SirenActionMixin } from '../utility/siren-action-mixin';
import './qr-bin';
import './qr-scan';

import { actions, ContextMixin } from './qr-context';

class QrIndex extends SirenActionMixin(NoMenuMixin(ContextMixin(StoreMixin(LitEntity)))) {
  static get properties() {
    return {
      serialNumber: { type: String, attribute: false },
      userFeatures: { type: Object, attribute: false },
      millEntity: { type: Object, attribute: false },
      action: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .unavailable {
        margin: 2rem;
        text-align: center;
      }
    `];
  }

  render() {
    if (!this.serialNumber) {
      return html`<qr-scan></qr-scan>`;
    }

    if (!this.millEntity) {
      return html`<bn-loading></bn-loading>`;
    }

    const millFeatures = this.millEntity?.properties?.features;
    const isFeatureEnabled = this.userFeatures?.qrLandingPage || millFeatures?.qrLandingPage;

    if (!isFeatureEnabled) {
      return html`
        <div class="unavailable">
          <h2>This feature is currently unavailable.</h2>
        </div>
      `;
    }

    switch (this.action) {
    case 'scan':
      return html`<qr-scan></qr-scan>`;

    case 'bin':
    default:
      return html`<qr-bin href=${this.binHref}></qr-bin>`;
    }
  }

  _stateChanged({ query, userFeatures }) {
    if (this.serialNumber !== query?.serialNumber) {
      this.serialNumber = query?.serialNumber;
      actions.setSerialNumber(this.serialNumber);
      this.fetchThings();
    }
    this.userFeatures = userFeatures;
  }

  contextChanged({ action }) {
    this.action = action;
  }

  async fetchThings() {
    const config = JSON.parse(import.meta.env.VITE_PROJECT_AWS_SSM_CONFIG);
    const apiRoot = config['api-root'];

    if (!apiRoot || !this.serialNumber) {
      return;
    }

    const url = new URL(apiRoot);

    const serialHref = `${url.origin}/bins/serial-numbers/${this.serialNumber}`;
    const serialEntity = await this.fetchSiren(serialHref, false);

    this.binHref = serialEntity?.getLink('about')?.href;
    const binEntity = await this.fetchSiren(this.binHref, false);

    const barnHref = binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/owner')?.href;
    const barnEntity = await this.fetchSiren(barnHref, false);

    const millHref = barnEntity?.getLink('https://api.binsentry.com/rel/account')?.href;
    this.millEntity = await this.fetchSiren(millHref, false);
  }
}

window.customElements.define('qr-index', QrIndex);
